import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'

export const scheduledNotSentRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.notSent,
  path: 'not-sent',
  redirect: { name: ScheduledRoutes.notSentOverview },
  component: () => import('@/components/views/scheduled/ScheduledNotSent.vue'),
  children: [
    {
      name: ScheduledRoutes.notSentOverview,
      path: '',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.notSent',
        tags: ['SCHEDULED_BAR_LIST'],
        resolvers: [
          {
            service: 'ScheduledNotSentWebsocketResolverService',
          },
        ],
        modules: [AppModule.ScheduledNotSent],
      },
      component: () => import('@/components/views/scheduled/ScheduledNotSentSms.vue'),
    },
    {
      name: ScheduledRoutes.notSentOverviewEmail,
      path: 'email',
      meta: {
        tabTitle: 'pageTabTitle.user.scheduled.notSentEmail',
        modules: [AppModule.ScheduledEmail, AppModule.Recipient, AppModule.CampaignsSenders],
        resolvers: [
          {
            service: 'ScheduledEmailCampaignFailedAttemptStateUpdatedWebsocketResolverService',
          },
        ],
      },
      component: () => import('@/components/views/scheduled/ScheduledNotSentEmail.vue'),
    },
  ],
}
